module.exports = __webpack_public_path__ + "img/QB_logo-500x500.ab3db398.png";